/**
 * Takes an array of strings and returns a string with the values in the array surrounded by single quotes and separated by commas.
 *
 *  @example
 *      stringifyArray(["a", "b", "c"]) // returns "('a', 'b', 'c')"
 */
export function stringifyArray(array: string[]) {
  return `(${array.map((item) => `'${item}'`).join(", ")})`;
}
